<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="overlayOrigin"
    [cdkConnectedOverlayOpen]="open"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    [cdkConnectedOverlayPositions]="positions"
>
    <div class="fcp-tooltip-wrapper">
        <div [class]="tooltipPositionClassName">
            <ng-content></ng-content>
        </div>
    </div>
</ng-template>
